var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBroadband(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_773)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.902 246.618H351.997C367.027 246.618 379.211 258.802 379.211 273.832V319.607H119.688V273.832C119.688 258.802 131.872 246.618 146.902 246.618Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.115,
    cy: 292.597,
    rx: 7.89604,
    ry: 8.46004,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.49,
    cy: 292.597,
    rx: 7.89604,
    ry: 8.46004,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.615,
    cy: 292.597,
    rx: 7.89604,
    ry: 8.46004,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.32 119.206C152.32 115.548 155.285 112.583 158.943 112.583V112.583C162.6 112.583 165.565 115.548 165.565 119.206V245.033H152.32V119.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.711,
    y: 326.711,
    width: 36.4238,
    height: 13.245,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.678,
    cy: 240.066,
    r: 40.287,
    fill: "#9f86c0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.227,
    cy: 246.137,
    rx: 12.1413,
    ry: 11.0375,
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.998 229.52C357.501 227.72 357.883 224.108 355.44 222.226C353.011 220.355 350.294 218.785 347.362 217.567C342.57 215.576 337.329 214.578 332.032 214.646C326.735 214.715 321.52 215.849 316.779 217.963C313.877 219.257 311.199 220.898 308.816 222.833C306.423 224.776 306.897 228.375 309.444 230.111V230.111C311.608 231.585 314.503 231.15 316.575 229.552C318.103 228.374 319.794 227.366 321.612 226.555C324.888 225.094 328.491 224.311 332.151 224.263C335.811 224.216 339.433 224.906 342.744 226.281C344.58 227.044 346.295 228.007 347.849 229.143C349.964 230.689 352.871 231.05 354.998 229.52V229.52Z",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.273,
    y: 326.438,
    width: 40.6082,
    height: 12.9721,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadband);
export default __webpack_public_path__ + "static/media/broad band.529238a6f1a60bdef4e9323eb2058927.svg";
export { ForwardRef as ReactComponent };